import { useMemo } from 'react'
import Image from 'next/image'
import { isEmpty } from 'lodash'

import { SellPoint2Type } from '../types'

const SellPoint2 = ({ blockData: data }: { blockData: string }) => {
  const blockData = useMemo(() => {
    if (data) {
      return JSON.parse(data) as SellPoint2Type
    }
  }, [data])

  if (
    !blockData?.title &&
    !blockData?.sub_title &&
    isEmpty(blockData?.specifications && isEmpty(blockData?.features))
  ) {
    return null
  }

  return (
    <div className="px-3">
      {/* pc端 */}
      <div className="mx-auto max-w-[1440px] max-xl:hidden">
        <div className="max-w-[780px]">
          <h2
            className="!mb-4 !mt-0 font-miSansSemiBold520 !text-pc-h2 !font-medium text-black"
            dangerouslySetInnerHTML={{ __html: blockData?.title ?? '' }}></h2>
          {blockData?.sub_title && (
            <p
              className="mt-4 font-miSansMedium380 !text-pc-2xl text-gray-5"
              dangerouslySetInnerHTML={{ __html: blockData?.sub_title ?? '' }}></p>
          )}
        </div>
        {blockData?.specifications && blockData?.specifications.length ? (
          <div className="mt-11 flex flex-wrap gap-x-[96px] gap-y-7">
            {blockData?.specifications?.map((item, index) => (
              <div key={index} className="flex items-center gap-3">
                {item.icon ? (
                  <Image src={item.icon} width={64} height={64} alt={item.title} />
                ) : null}
                <div>
                  <div
                    className="font-miSansDemiBold450 text-5xl text-gray-8"
                    dangerouslySetInnerHTML={{ __html: item.title }}></div>
                  <p
                    className="m-0 !mb-0 font-miSansRegular330 !text-2xl text-gray-4"
                    dangerouslySetInnerHTML={{ __html: item.subtitle }}></p>
                </div>
              </div>
            ))}
          </div>
        ) : null}
        <div className="mt-14 flex flex-col gap-14">
          {blockData?.features?.map((item, index) => (
            <div key={index} className="flex items-center justify-between gap-14">
              <div className={`${index % 2 === 0 ? 'order-1' : 'order-2'}`}>
                <div
                  className="font-miSansSemiBold520 text-6xl text-black"
                  dangerouslySetInnerHTML={{ __html: item.title }}></div>
                <div
                  className="mt-4 font-miSansMedium380 text-pc-2xl text-gray-5"
                  dangerouslySetInnerHTML={{
                    __html: item.description.replace(/\r\n|\n|\r/g, '<br/>'),
                  }}></div>
              </div>
              <Image
                src={item.pc_image}
                alt={item.title}
                width={894}
                height={447}
                className={`${index % 2 === 0 ? 'order-2' : 'order-1'} w-[62.2%] max-w-[894px] flex-shrink-0 rounded-xl bg-gray-4`}
              />
            </div>
          ))}
        </div>
      </div>
      {/* mb端 */}
      <div className="xl:hidden">
        <div className="max-w-[310px]">
          <h2
            className="!mb-[6px] !mt-0 font-miSansDemiBold450 !text-[18px]"
            dangerouslySetInnerHTML={{ __html: blockData?.title ?? '' }}></h2>
          {blockData?.sub_title && (
            <p
              className="mt-2 font-miSansRegular330 !text-sm text-gray-5"
              dangerouslySetInnerHTML={{ __html: blockData?.sub_title ?? '' }}></p>
          )}
        </div>
        {blockData?.specifications && blockData?.specifications.length ? (
          <div className="mt-6 flex w-fit grid-cols-2 flex-wrap gap-x-[28px] gap-y-7 max-md:grid">
            {blockData?.specifications?.map((item, index) => (
              <div key={index} className="flex items-center gap-[6px] max-md:min-w-24">
                {item.icon ? (
                  <Image
                    src={item.icon}
                    style={{ objectFit: 'cover' }}
                    width={28}
                    height={28}
                    alt={item.title}
                  />
                ) : null}
                <div>
                  <div
                    className="font-miSansRegular330 text-base text-gray-8 xl:font-miSansMedium380"
                    dangerouslySetInnerHTML={{ __html: item.title }}></div>
                  <p
                    className="!m-0 font-miSansRegular330 !text-sm text-gray-4 xl:font-miSansMedium380"
                    dangerouslySetInnerHTML={{ __html: item.subtitle }}></p>
                </div>
              </div>
            ))}
          </div>
        ) : null}
        {blockData?.features && blockData?.features.length ? (
          <div className="mt-7 flex flex-col gap-3">
            {blockData?.features?.map((item, index) => (
              <div key={index} className="overflow-hidden rounded-lg bg-gray-1">
                <Image
                  width={350}
                  height={188}
                  src={item.pc_image}
                  alt={item.title}
                  className="w-full rounded-lg"
                />
                <div className="p-4">
                  <div
                    className="font-miSansDemiBold450 text-lg text-black"
                    dangerouslySetInnerHTML={{ __html: item.title }}></div>
                  <div
                    className="mt-2 font-miSansRegular330 text-sm text-gray-5"
                    dangerouslySetInnerHTML={{
                      __html: item.description.replace(/\r\n|\n|\r/g, '<br/>'),
                    }}></div>
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default SellPoint2
